import {useEffect} from "react";
import {connect} from "formik";
import _ from 'lodash';

import {usePrevious} from "../utils/hooks";

const FormListener = ({onChange = _.noop, formik}) => {
	const {values} = formik;
	const prevValues = usePrevious(values);

	useEffect(() => {
		if (prevValues) {
			onChange({prevValues, nextValues: values, formik});
		}
	}, [values]);

	return null;
};

export default connect(FormListener);
